export const MEDICAL_QUESTIONNAIRES: Record<string, string> = {
  'Chest pains (or angina):':
    'Have you ever had, or are currently being treated for chest pains (or angina)?',
  'Heart attack:':
    'Have you ever had, or are currently being treated for heart attack?',
  'Rheumatic fever':
    'Have you ever had, or are currently being treated for rheumatic fever?',
  'Heart murmus':
    'Have you ever had, or are currently being treated for heart murmurs?',
  'Pacemaker fitted':
    'Have you ever had, or are currently fitted with a pacemaker?',
  'High blood pressure':
    'Have you ever had, or are currently being treated for high blood pressure?',
  Asthma: 'Have you ever had, or are currently being treated for Asthma?',
  Tuberculosis:
    'Have you ever had, or are currently being treated for tuberculosis?',
  'Coughing up blood':
    'Have you ever had, or are currently being treated for coughing up blood?',
  'Lung embolus (PE)':
    'Have you ever had, or are currently being treated for lung embolus (PE)?',
  Epilepsy: 'Have you ever had, or are currently being treated for epilepsy?',
  'Stroke or mini stroke (TIA)':
    'Have you ever had, or are currently being treated for stroke or mini stroke (TIA)?',
  'Sleep apnoea':
    'Have you ever had, or are currently being treated for sleep apnoea?',
  'Hiatus hernia':
    'Have you ever had, or are currently being treated for hiatus hernia?',
  Jaundice: 'Have you ever had, or are currently being treated for jaundice?',
  'Hepatitis A, B, or C':
    'Have you ever had, or are currently being treated for hepatitis A, B, or C?',
  'HIV or AIDS':
    'Have you ever had, or are currently being treated for HIV or AIDS?',
  'Blood disorders (such as sickle cell, leukaemia, etc.)':
    'Have you ever had, or are currently being treated for blood disorders (such as sickle cell, leukaemia, etc.)?',
  'Serious bleeding or bruising':
    'Have you ever had, or are currently being treated for serious bleeding or bruising?',
  'Leg thrombosis (DTV)':
    'Have you ever had, or are currently being treated for leg thrombosis (DTV)?',
  'Thyroid problems':
    'Have you ever had, or are currently being treated for thyroid problems?',
  Diabetes: 'Have you ever had, or are currently being treated for diabetes?',
  Cancer: 'Have you ever had, or are currently being treated for cancer?',
  Arthritis: 'Have you ever had, or are currently being treated for arthritis?',
  'MRSA (methicillin - resistant staphylococcus aureus)':
    'Have you ever had, or are currently being treated for MRSA (methicillin - resistant staphylococcus aureus)?',
  'MSSA (methicillin - sensitive staphylococcus aureus)':
    'Have you ever had, or are currently being treated for MSSA (methicillin - sensitive staphylococcus aureus)?',
};
